import { Injectable } from "@angular/core";
import { EntityConfigurationConnector } from "./entity-configuration.connector";
import { AppServerEntityConfigurationConnector } from "../../app-server-connectors";
import { AuthenticationService, CachingService, IAMService, UIService } from "src/app/services/services.module";
import { APIResponse, EntityAddFormDocument, EntityType, EntityViewDocument } from "server-model";

@Injectable()
export class EntityConfigurationDataService {
    private entityConfigurationConnector: EntityConfigurationConnector;

    constructor(
        private cachingService: CachingService,
        private iamService: IAMService,
        private authenticationService: AuthenticationService,
        private uiService: UIService,
    ) {
        this.entityConfigurationConnector = new AppServerEntityConfigurationConnector(this.iamService, this.authenticationService, this.uiService)
    }

    async getEntityView(organisationId: string, entityType: EntityType): Promise<APIResponse> {
        const response = await this.entityConfigurationConnector.getEntityView(organisationId, entityType);
        return response;
    }
    async createEntityView(entityViewDocument: EntityViewDocument): Promise<APIResponse> {
        const response = await this.entityConfigurationConnector.createEntityView(entityViewDocument);
        return response;
    }
    async deleteEntityView(organisationId: string, entityType: EntityType): Promise<APIResponse> {
        const response = await this.entityConfigurationConnector.deleteEntityView(organisationId, entityType);
        return response;
    }
    async updateEntityView(organisationId: string, entityType: EntityType, entityViewDocument: EntityViewDocument): Promise<APIResponse> {
        const response = await this.entityConfigurationConnector.updateEntityView(organisationId, entityType, entityViewDocument);
        return response;
    }



    async getEntityAddForm(organisationId: string, entityType: EntityType): Promise<APIResponse> {
        const response = await this.entityConfigurationConnector.getEntityAddForm(organisationId, entityType);
        return response;
    }
    async createEntityAddForm(entityAddFormDocument: EntityAddFormDocument): Promise<APIResponse> {
        const response = await this.entityConfigurationConnector.createEntityAddForm(entityAddFormDocument);
        return response;
    }
    async deleteEntityAddForm(organisationId: string, entityType: EntityType): Promise<APIResponse> {
        const response = await this.entityConfigurationConnector.deleteEntityAddForm(organisationId, entityType);
        return response;
    }
    async updateEntityAddForm(organisationId: string, entityType: EntityType, entityAddFormDocument: EntityAddFormDocument): Promise<APIResponse> {
        const response = await this.entityConfigurationConnector.updateEntityAddForm(organisationId, entityType, entityAddFormDocument);
        return response;
    }
}
